var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Lists extends Component {
    constructor() {
        super('Lists', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-delete-list').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                const message = $('html').attr('lang') == 'fr_FR' ? 'Êtes-vous sûr de vouloir supprimer la liste «list_name»?' : 'Are you sure you want to delete the list "list_name"?';
                if (!confirm(message.replace('list_name', button.prev().text())))
                    event.preventDefault();
            }));
            // Component initialization done
            this.success();
        });
    }
}
